<template>
  <div>
    <ElDropdown trigger="click" @command="handleActions">
      <div class="p-1">
        <WcIconMenu color="rgb(4,4,4,0.77)"/>
      </div>
      <ElDropdownMenu>
        <div class="p-2 flex flex-col gap-1">
          <ElDropdownItem class="flex gap-2 p-2 align-items-center hover:bg-gray-100 cursor-pointer" :command="InboxActionsEnum.MARK_ALL_READ" >
            <WcIconSquareTick />
            <WcTypography :title="t('markAllAsRead')" size="smd" />
          </ElDropdownItem>
          <ElDropdownItem class="flex gap-2 p-2 align-items-center hover:bg-gray-100 cursor-pointer" :command="InboxActionsEnum.MARL_ALL_UNREAD" >
            <WcIconSquaredMinus />
            <WcTypography :title="t('markAllAsUnread')" size="smd" />
          </ElDropdownItem>
          <ElDropdownItem class="flex gap-2 p-2 align-items-center hover:bg-gray-100 cursor-pointer" :command="InboxActionsEnum.DELETE_ALL_READ_NOTIFICATIONS">
            <WcIconBin color="gray" />
            <WcTypography :title="t('deleteAllReadNotifications')" size="smd" />
          </ElDropdownItem>
          <ElDropdownItem class="flex gap-2 p-2 align-items-center hover:bg-gray-100 cursor-pointer" :command="InboxActionsEnum.DELETE_ALL_NOTIFICATIONS">
            <WcIconBin color="red" />
            <WcTypography :title="t('deleteAllNotifications')" size="smd" color="red" />
          </ElDropdownItem>
        </div>
      </ElDropdownMenu>
    </ElDropdown>
    <ActionConfirmationDialog
      :data="dialogData"
      @close-dialog="closeDialog"
      @confirm="deleteNotification"
    />
  </div>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import WcTypography from '@/components/UILibrary/Typography/WcTypography.vue'
import WcIconSquareTick from '@/components/UILibrary/Icons/WcIconSquareTick.vue'
import WcIconSquaredMinus from '@/components/UILibrary/Icons/WcIconSquaredMinus.vue'
import WcIconBin from '@/components/UILibrary/Icons/WcIconBin.vue'
import { InboxActionsEnum } from '@/views/home-page/inbox/models/inbox-type.enum'
import InboxNotificationsResource from '@/api/inbox/inboxNotifications'
import { handleError } from '@/utils/request'
import WcIconMenu from '@/components/UILibrary/Icons/WcIconMenu.vue'
import ActionConfirmationDialog from '@/views/recruiter/hiring-plan/components/ActionConfirmationDialog.vue'
import { ConfirmationDialogData } from '@/views/recruiter/hiring-plan/models/requisition-payload.dto'

@Component({
  name: 'InboxActions',
  computed: {
    InboxActionsEnum() {
      return InboxActionsEnum
    }
  },
  components: {
    ActionConfirmationDialog,
    WcIconMenu,
    WcIconBin,
    WcIconSquaredMinus,
    WcIconSquareTick,
    WcTypography
  }
})
export default class InboxActions extends Vue {
  inboxNotificationsResource = new InboxNotificationsResource()
  deleteAllReadNotificationsState = false
  dialogData: ConfirmationDialogData = {
    title: '',
    description: '',
    confirmationText: '',
    isVisible: false,
    loading: false,
    buttonType: 'primary'
  }

  async handleActions(type: InboxActionsEnum): Promise<void> {
    switch (type) {
      case InboxActionsEnum.MARK_ALL_READ:
        await this.inboxNotificationsResource.store({ isRead: true })
        this.$emit('refresh')
        break

      case InboxActionsEnum.MARL_ALL_UNREAD:
        await this.inboxNotificationsResource.store({ isRead: false })
        this.$emit('refresh')
        break

      case InboxActionsEnum.DELETE_ALL_NOTIFICATIONS:
        this.dialogData = {
          title: this.getDeleteNotificationsTitle,
          description: this.$t('general.thisActionCannotBeUnDone').toString(),
          confirmationText: this.$t('general.delete').toString(),
          isVisible: true,
          loading: false,
          buttonType: 'danger'
        }
        this.deleteAllReadNotificationsState = false
        break

      case InboxActionsEnum.DELETE_ALL_READ_NOTIFICATIONS:
        this.dialogData = {
          title: this.getDeleteNotificationsTitle,
          description: this.$t('general.thisActionCannotBeUnDone').toString(),
          confirmationText: this.$t('general.delete').toString(),
          isVisible: true,
          loading: false,
          buttonType: 'danger'
        }
        this.deleteAllReadNotificationsState = true
        break
    }
  }

  closeDialog(): void {
    this.dialogData.isVisible = false
  }

  get getDeleteNotificationsTitle(): string {
    if (this.deleteAllReadNotificationsState) {
      return this.$t('homePage.inbox.confirmationToDeleteAllReadNotifications').toString()
    }
    return this.$t('homePage.inbox.confirmationToDeleteAllNotifications').toString()
  }

  async deleteNotification(): Promise<void> {
    this.dialogData.loading = true
    try {
      await this.inboxNotificationsResource.deleteNotifications(this.deleteAllReadNotificationsState)
      if (this.deleteAllReadNotificationsState) {
        this.$message.success(this.$t('homePage.inbox.successMessages.deletedAllReadNotifications').toString())
      } else {
        this.$message.success(this.$t('homePage.inbox.successMessages.deletedAllNotifications').toString())
      }
      this.closeDialog()
      this.$emit('refresh')
    } catch (e) {
      handleError(e, this.$message)
    } finally {
      this.dialogData.loading = false
    }
  }

  t(key: string): string {
    return this.$t(`homePage.inbox.${key}`).toString()
  }
}
</script>
<style scoped>

</style>
